import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { where } from "firebase/firestore";
import { getSingleDoc, dbCollections } from "../firebase";

export default function BlogDetailedPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const _data = await getSingleDoc({
        collectionName: dbCollections.BLOGS,
        condition: where("urlKey", "==", id),
      });
      setData(_data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const urlData = location?.state?.data;
    if (urlData) {
      setData({ ...urlData });
      setLoading(false);
    } else if (id) {
      fetchData();
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full"></div>
      </div>
    );
  }

  return (
    <section className="w-full max-w-4xl mx-auto px-4 py-12">
      <button
        onClick={() => navigate("/")}
        className="mb-6 flex items-center gap-2 text-blue-600 hover:underline"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        Back to Home
      </button>

      <h1 className="text-3xl sm:text-4xl font-bold mb-4">{data?.title}</h1>

      {data?.createdAt?.seconds && (
        <p className="text-gray-500 text-sm mb-6">
          {new Date(data.createdAt.seconds * 1000).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
      )}

      {data?.imageUrl && (
        <div className="w-full h-[300px] sm:h-[400px] rounded-xl overflow-hidden shadow-md mb-8">
          <img
            src={data.imageUrl}
            alt={data.title}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
    </section>
  );
}
